var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    enableBackground: "new 0 0 66 66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Orders") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.7,49.1H25.9c-1.2-1-2.8-1.7-4.5-1.7c-1.7,0-3.3,0.6-4.6,1.7H9.1V38c2.4,1.3,5.2,2,8.1,2h0c4.7,0,9.2-1.9,12.5-5.2   c3.3-3.3,5.2-7.8,5.2-12.5c0-0.8,0-1.5-0.2-2.3h8.1c0.5,0,0.9,0.4,0.9,0.9V49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4,49.5c-2.8,0-5,2.3-5,5c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5S24.1,49.5,21.4,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,52.5c0,0.3,0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.7,0.3h4.4c0.1-0.8,0.4-1.6,0.8-2.3H9.1V52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3,53.5h15.5v-2.3H27.5C27.9,51.8,28.2,52.6,28.3,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5,39.6c0-0.8-0.3-1.5-0.8-2c-3.5-3.5-5.8-5.8-9.3-9.3c-0.5-0.5-1.3-0.9-2-0.9h-5.1c-0.8,0-1.5,0.6-1.6,1.4   c0,0.1,0,0.1,0,0.2c0,2.5,0-9,0,24.4l2.5,0c0.5-3.5,3.4-6,6.9-6c3.5,0,6.4,2.6,6.9,6h2c0.3,0,0.5-0.2,0.5-0.5L64.5,39.6z    M51.3,45.4h-2.8c-0.5,0-1-0.4-1-1c0-0.6,0.5-1,1-1h2.8c0.6,0,1,0.4,1,1C52.3,44.9,51.9,45.4,51.3,45.4z M61.3,39.5H48.6v-9.3   c0.1,0,4.4-0.1,4.1-0.1c0.3,0,0.6,0.1,0.8,0.3c2,2,6.2,6.2,7.4,7.4c0.2,0.2,0.3,0.5,0.3,0.8V39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,49.5c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5c2.8,0,5-2.3,5-5C60.1,51.7,57.9,49.5,55.1,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,38c4.2,0,8.1-1.6,11.1-4.6c3-3,4.6-6.9,4.6-11.1c0-8.7-7.1-15.7-15.7-15.7c-4.2,0-8.1,1.6-11.1,4.6   c-3,3-4.6,6.9-4.6,11.1C1.5,30.9,8.5,38,17.2,38L17.2,38z M5.5,22.3c0-3.1,1.2-6.1,3.4-8.3c2.2-2.2,5.2-3.4,8.3-3.4   c6.5,0,11.7,5.3,11.7,11.7c0,6.5-5.2,11.7-11.7,11.7h0C10.8,34,5.5,28.7,5.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,33.2c0.6,0,1-0.4,1-1l0-0.7c0-0.6-0.4-1-1-1h0c-0.6,0-1,0.4-1,1l0,0.7C16.2,32.7,16.7,33.2,17.2,33.2   C17.2,33.2,17.2,33.2,17.2,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,14c0.6,0,1-0.4,1-1v-0.7c0-0.6-0.4-1-1-1s-1,0.4-1,1V13C16.2,13.6,16.6,14,17.2,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,21.3L8,21.3l-0.7,0c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h0l0.7,0c0.6,0,1-0.4,1-1C9,21.7,8.5,21.3,8,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,23.2L26.5,23.2l0.7,0c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h0l-0.7,0c-0.6,0-1,0.4-1,1C25.5,22.8,25.9,23.2,26.5,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,28.1l-0.5,0.5c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l0.5-0.5c0.4-0.4,0.4-1,0-1.4S10.4,27.7,10,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,16.4l0.5-0.5c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L23,15c-0.4,0.4-0.4,1,0,1.4C23.4,16.8,24.1,16.8,24.5,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,16.4c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4l-0.5-0.5c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4L10,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,28.1c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l0.5,0.5c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4L24.5,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,25.6c-0.2,0.5-0.8,0.7-1.3,0.5l-4.5-2c-0.5,0.4-1,0.6-1.7,0.6h0c-1.4,0-2.5-1.1-2.5-2.5c0-1,0.6-1.9,1.5-2.3v-3.3   c0-0.6,0.5-1,1-1s1,0.4,1,1V20c0.3,0.1,0.5,0.3,0.8,0.5c0.5,0.5,0.7,1.1,0.7,1.8c0,0,0,0,0,0l4.5,2C24.7,24.5,24.9,25.1,24.7,25.6z   "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.f411046c1991d8c202ebfd5eb68e99c1.svg";
export { ForwardRef as ReactComponent };